/**
 * Percentage of a scoped stat value against its network total, as a whole number.
 * Returns null when either side is missing or the total is not positive (the UI
 * hides the percentage rather than showing a nonsense value). Clamped to [0, 100]:
 * scoped counts come from spatial queries against overlapping, unclipped polygons,
 * so values slightly above the network total are arithmetically possible.
 */
export function percentOfTotal(local: number | null | undefined, total: number | null | undefined): number | null {
    if (local == null || total == null) return null;
    if (!isFinite(local) || !isFinite(total) || total <= 0) return null;
    return Math.min(100, Math.max(0, Math.round((local / total) * 100)));
}
